import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type HistoryAction = 'viewed' | 'added' | 'updated' | 'removed'

export interface HistoryEntry {
  id: string
  cardId: string
  cardName: string
  cardImageUrl?: string
  setCode: string
  action: HistoryAction
  collectionName?: string
  previousQuantity?: number
  newQuantity?: number
  timestamp: number
  cardmarketUrl?: string
  blueprintId?: number
}

interface CardHistoryStore {
  entries: HistoryEntry[]
  addEntry: (entry: Omit<HistoryEntry, 'id' | 'timestamp'>) => void
  clearHistory: () => void
}

const MAX_ENTRIES = 50

export const useCardHistoryStore = create<CardHistoryStore>()(
  persist(
    (set, get) => ({
      entries: [],

      addEntry: (entry) => {
        const now = Date.now()
        const entries = get().entries

        // Deduplicate consecutive "viewed" for same card
        if (
          entry.action === 'viewed' &&
          entries.length > 0 &&
          entries[0].action === 'viewed' &&
          entries[0].cardId === entry.cardId
        ) {
          // Update timestamp of existing entry instead of adding duplicate
          set({
            entries: [
              { ...entries[0], timestamp: now },
              ...entries.slice(1),
            ],
          })
          return
        }

        const newEntry: HistoryEntry = {
          ...entry,
          id: `${now}-${Math.random().toString(36).slice(2, 7)}`,
          timestamp: now,
        }

        set({
          entries: [newEntry, ...entries].slice(0, MAX_ENTRIES),
        })
      },

      clearHistory: () => set({ entries: [] }),
    }),
    {
      name: 'card-history',
    }
  )
)
